import axios from 'axios';

const api = axios.create({
    baseURL: 'https://stock.libertytradecorp.com:9000',
    withCredentials: true,
});

// Add request interceptor for authentication
api.interceptors.request.use(
    async (config) => {
        // console.log('DEBUG - API Request URL:', config.baseURL + config.url);
        
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
